import { __decorate } from "tslib";
import { Vue, Component, Mixins, Prop } from 'vue-property-decorator';
import { uiMapper } from '@/services/store/modules/ui/store';
import { dataMapper } from '@/services/store/modules/data/store';
import IconSvg from './IconSvg.vue';
import SelectApp from './SelectApp.vue';
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(['formCallIsShown', 'breakpoint'])
    }
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(['videoLink', 'quiz']),
        ...dataMapper.mapGetters(['quizAnswer'])
    },
    methods: {
        ...dataMapper.mapMutations(['updateQuizField', 'clearQuiz', 'removeQuizValue'])
    }
});
let StepsQuizSelect = class StepsQuizSelect extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.selectActiveIndexes = null;
    }
    get isGtLg() { return this.breakpoint === 'lg' || this.breakpoint === 'xl'; }
    get isLtMd() { return this.breakpoint === 'xs' || this.breakpoint === 'sm'; }
    get steps() { return this.quiz.data; }
    created() {
        this.clearQuiz();
    }
    updateValueSex(payload) {
        const { value, vIndex } = payload;
        this.updateValue(this.stepIndex, value, vIndex, 0);
    }
    updateValueAge(payload) {
        const { value, vIndex } = payload;
        this.updateValue(this.stepIndex, value, vIndex, 1);
    }
    updateValue(index, value, valueIndex, subValueIndex) {
        this.$emit('updateValue', { index, value, valueIndex, subValueIndex });
    }
    onRemoveClick(valueIndex) {
        this.removeQuizValue({ stepIndex: this.stepIndex, valueIndex });
    }
};
__decorate([
    Prop()
], StepsQuizSelect.prototype, "step", void 0);
__decorate([
    Prop()
], StepsQuizSelect.prototype, "stepIndex", void 0);
StepsQuizSelect = __decorate([
    Component({
        components: {
            IconSvg,
            SelectApp
        },
    })
], StepsQuizSelect);
export default StepsQuizSelect;
